import { StandardEvents } from '@shopify/events';

function formatTotal(cents, currency) {
  try {
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
    }).format(cents / 100);
    return `${amount} ${currency}`;
  } catch (e) {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

if (!customElements.get('header-cart-total')) {
  class HeaderCartTotal extends HTMLElement {
    connectedCallback() {
      this.onUpdate = this.onUpdate.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
      document.addEventListener(StandardEvents.cartLinesUpdate, this.onUpdate);
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      document.removeEventListener(StandardEvents.cartLinesUpdate, this.onUpdate);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    onUpdate(event) {
      const done = event?.promise ? event.promise.catch(() => {}) : Promise.resolve();
      done.then(() => this.refresh());
    }

    onPageShow(event) {
      if (event.persisted) this.refresh();
    }

    async refresh() {
      try {
        const root = window.Theme?.routes?.cart_url || '/cart';
        const response = await fetch(`${root}.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        const cart = await response.json();
        const currency = cart.currency || this.dataset.currency;
        this.textContent = formatTotal(cart.total_price, currency);
        this.hidden = cart.item_count === 0;
      } catch (e) {
        // Keep the last known total
      }
    }
  }

  customElements.define('header-cart-total', HeaderCartTotal);
}
